import { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { useForm } from "react-hook-form";
import PrimaryButton from "components/Button/PrimaryButton";
import Button from "components/Button";
import FormNovaCobranca from "../../pages/Admin/Financeiro/Receita/CrmCobranca/Detalhes/components/HistoricoDeCobranca/FormNovaCobranca";
import { NovoHistoricoCobranca } from "features/cobranca/typings";
import useSaveHistoricoCobranca from "core/features/cobranca/hooks/useSaveHistoricoCobranca";
import { Modal } from "antd";
import useHistoricoCobrancaItem from "core/features/cobranca/hooks/useHistoricoCobrancaItem";
import { useLoading } from "components/GlobalLoading";

interface ModalHistoricoCobrancaProps {
  isOpen: boolean;
  onClose: () => any;
  onSaved: () => any;
  tenantId: string;
  pessoaId: string;
  unidadeId: string;
  historicoId?: string;
}

function ModalHistoricoCobranca({
  isOpen,
  onClose,
  onSaved,
  tenantId,
  pessoaId,
  unidadeId,
  historicoId,
}: ModalHistoricoCobrancaProps) {
  const { data, isLoading, isFetching } = useHistoricoCobrancaItem(historicoId);

  const { control, handleSubmit, watch, reset } = useForm<
    NovoHistoricoCobranca & { checkboxNovoContato: boolean }
  >({
    reValidateMode: "onChange",
    mode: "onTouched",
    defaultValues: {
      pessoaResponsavelId: pessoaId,
    },
  });

  const { mutate: handleSave, isLoading: isLoadingSave } =
    useSaveHistoricoCobranca(historicoId);

  const onSubmit = async (data: NovoHistoricoCobranca) => {
    const dataSubmit = { ...data, unidadeId: unidadeId };

    handleSave(dataSubmit, {
      onSuccess: async () => {
        reset();
        onSaved();

        showSuccess("Cobrança salva com sucesso");
      },
      onError: (res) => {
        showErrorAxios(res);
      },
    });
  };

  useEffect(() => {
    if (data) {
      reset({
        ...data,
        checkboxNovoContato: !!data.dataAgendamento,
        hora: data.hora?.slice(0, 5),
        horaAgendamento: data.horaAgendamento?.slice(0, 5),
      });
    }
  }, [data, reset]);

  useLoading(isLoading || isFetching);

  return (
    <Modal
      visible={isOpen}
      title="Histórico de cobrança"
      footer={
        <Box
          display="flex"
          gridGap={6}
          justifyContent="flex-end"
          flex={1}
          mt={8}
        >
          <Button isDisabled={isLoading} onClick={onClose}>
            Cancelar
          </Button>

          <PrimaryButton
            isLoading={isLoading || isLoadingSave}
            isDisabled={isLoading || isLoadingSave}
            onClick={() => handleSubmit(onSubmit)()}
          >
            Salvar
          </PrimaryButton>
        </Box>
      }
      onCancel={onClose}
      width="781px"
    >
      <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
        <>
          <Box>
            <FormNovaCobranca
              pessoaId={pessoaId}
              tenantId={tenantId}
              unidadeId={unidadeId}
              isEdit={!!historicoId}
              control={control}
              watch={watch}
            />
          </Box>
        </>
      </form>
    </Modal>
  );
}

export default ModalHistoricoCobranca;
